import { EmailSettingsFlags } from 'types';

export const EMAIL_SETTINGS: { title: string; hint: string; field: EmailSettingsFlags }[] = [
  { title: 'New Transaction', hint: '1', field: 'createTransaction' },
  { title: 'Transaction Signed', hint: '2', field: 'signTransaction' },
  { title: 'Transaction Executed', hint: '3', field: 'executeTransaction' },
  // { title: 'Message Signature Created', hint: '4', field: 'createMessageSignature' },
  // { title: 'Message Signature Signed', hint: '5', field: 'signMessageSignature' },
  // { title: 'Message Signature Finalized', hint: '6', field: 'finalizeMessageSignature' },
  { title: 'Updates from Asigna', hint: '7', field: 'asignaUpdates' },
  // { title: 'Asigna Pro Expiration', hint: '8', field: 'asignaExpiry' },
];
